import axios from "axios";
import { API_ENDPOINT, TOKEN_KEY } from "../config";
import { generateURL } from "../utilities";

const getToken = () => {
  return sessionStorage.getItem(TOKEN_KEY);
};

/**
 * Export brands with the same filters as the list API.
 * @param {Object} params - Same filter params as brand/list (searchQuery, limit). Optionally limit for export size.
 * @returns {Promise<AxiosResponse>} Response with responseType: 'blob' for file download.
 */
export const exportBrands = async (params) => {
  const fd = new FormData();
  const exportParams = { ...params };
  if (exportParams.pageNo !== undefined) delete exportParams.pageNo;
  exportParams.limit = exportParams.limit ?? 9999;
  for (const key in exportParams) {
    if (exportParams.hasOwnProperty(key) && exportParams[key] !== undefined && exportParams[key] !== null) {
      fd.append(key, exportParams[key]);
    }
  }
  const res = await axios({
    method: "post",
    url: `${API_ENDPOINT}brands/export${generateURL(exportParams)}`,
    data: fd,
    responseType: "blob",
    headers: {
      Authorization: getToken() ? `Bearer ${getToken()}` : "",
    },
  });
  return res;
};
